import React from 'react';
import styled from 'styled-components';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const CategoriesContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const CategoryRow = styled.div`
  display: flex;
  width: 100%;
  height: 700px;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
  }
`;

const CategoryItem = styled.div<{ $bgImage: string }>`
  flex: 1;
  height: 100%;
  background: url(${props => props.$bgImage}) center/cover;
  position: relative;
  cursor: pointer;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2));
  }

  @media (max-width: 768px) {
    height: 500px;
  }
`;

const CategoryContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  z-index: 2;
  padding: 20px;
`;

const CategoryTitle = styled.h3`
  font-size: 2rem;
  font-weight: 300;
  margin-bottom: 15px;
  letter-spacing: 2px;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const CategorySubtitle = styled.p`
  font-size: 1rem;
  margin-bottom: 25px;
  opacity: 0.9;
  max-width: 200px;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const CategoryButton = styled.button`
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 12px 25px;
  border-radius: 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
  }
`;

const CategoriesSection: React.FC = () => {
  const navigate = useNavigate();
  
  const categories = [
    {
      id: 3,
      title: 'KINALIK',
      subtitle: 'Özel kına geceniz için',
      image: '/pictures/kinalik/kinalik-1.webp',
      path: '/kinaliklar'
    },
    {
      id: 1,
      title: 'GELİNLİK',
      subtitle: 'Hayalinizdeki gelinlik için',
      image: '/pictures/gelinlik/gelinlik.webp',
      path: '/gelinlikler'
    },
    {
      id: 2,
      title: 'ABİYE',
      subtitle: 'Şık ve zarif tasarımlar',
      image: '/pictures/abiye/abiye.webp',
      path: '/abiyeler'
    }
  ];

  const handleCategoryClick = (path: string) => {
    navigate(path);
  };

  return (
    <CategoriesContainer>
      <CategoryRow>
        {categories.map((category) => (
          <CategoryItem 
            key={category.id} 
            $bgImage={category.image}
            onClick={() => handleCategoryClick(category.path)}
          >
            <CategoryContent>
              <CategoryTitle>{category.title}</CategoryTitle>
              <CategorySubtitle>{category.subtitle}</CategorySubtitle>
              <CategoryButton>
                Keşfet
                <ArrowRight size={16} />
              </CategoryButton>
            </CategoryContent>
          </CategoryItem>
        ))}
      </CategoryRow>
    </CategoriesContainer>
  );
};

export default CategoriesSection;
